module Meevo.Components.Controls {

    import FileTypes = Meevo.Model.FileTypes;

    class MultipleFileUploadComponent implements angular.IComponentController {
        fileType: FileTypes;
        model: Meevo.Model.ICustomDataResource[];
        disabled: boolean;

        static $inject = [
            '$scope',
            '$mdDialog',
            'meevo.components.modal.ModalService',
        ];

        constructor(
            private $scope: ng.IScope,
            private $mdDialog: ng.material.IDialogService,
            private modalService: Meevo.Components.Modal.IModalService
        ) {
        }

        openUploadDialog() {
            this.$scope.fileType = this.fileType;
            this.$scope.updateGuid = true;
            this.$scope.meevoFile = null;

            let options = {
                scope: this.$scope,
                templateUrl: 'app/components/fileUpload/fileUploadModalTemplate.html',
                controller: 'meevo.components.fileupload.FileUploadModalController',
                controllerAs: 'vm',
                preserveScope: true,
                skipHide: true,
                multiple: true,
                additionalClassName: 'file-upload-modal',
            };
            this.$mdDialog.show(options)
                .then((uploadData) => {
                    this.model.push({
                        resourceType: this.fileType,
                        meevoFile: uploadData.meevoFile,
                        fileGuid: uploadData.fileGuid,
                        contentType: uploadData.mimeType,
                        isStorageUpdated: uploadData.isStorageUpdated,
                    })
                });
        }

        getFileUrl(data: Meevo.Model.ICustomDataResource) {
            return Meevo.Model.StorageFileHelper.sourceUri(data, '');
        }

        getFileName(data: Meevo.Model.ICustomDataResource) {
            return Meevo.Model.StorageFileHelper.fileName(data);
        }

        remove(id: string) {
            if (this.disabled) {
                return;
            }

            const modalOptions = {
                showCancelButton: true,
                cancelButtonContentKey: 'LABEL_NO',
                cancelButtonHotKey: 'MODAL_NO_BUTTON',
                okButtonHotKey: 'MODAL_YES_BUTTON',
                okButtonContentKey: 'LABEL_YES'
            };
            this.modalService
                .warning('MESSAGE_DELETE_CONFIRMATION', 0, true, modalOptions)
                .then((confirmResult: boolean) => {
                    if (!confirmResult) {
                        return;
                    }

                    this.model = this.model.filter((item) => item.fileGuid !== id);
                });
        }
    }


    angular.module('meevo.components.controls')
        .component('meevoMultipleFileUploadComponent', <angular.IComponentOptions>{
            templateUrl: 'app/components/controls/multiple-file-upload/multiple-file-upload.component.html',
            controller: MultipleFileUploadComponent,
            controllerAs: '$ctrl',
            bindings: {
                model: '=ngModel',
                fileType: '=',
                disabled: '=?ngDisabled'
            }
        });
}
